const getIsIframe = () => {
  try {
    return window.self !== window.top;
  } catch (e) {
    return true;
  }
};

const isIframe = getIsIframe();

export { isIframe };
